import React from 'react';
import { Refrigerator, Recycle, Returns } from '@one-thd/sui-icons';

export const protectionPointsData = [
  {
    description: 'Covers 100% parts & labor for breakdowns & defects'
  },
  {
    description: '2- or 3-Day Service Guarantee based on your location'
  },
  {
    description: '24/7 customer support & easy online claims'
  },
  {
    description: '30% plan reimbursement if no service claims are made'
  },
  {
    description: 'No deductibles or hidden fees'
  }
];

export const installationOptionsData = [
  {
    icon: <Refrigerator size="large" />,
    title: 'Professional Setup',
    description: 'Appliance connected and inspected for damage'
  },
  {
    icon: <Recycle size="large" />,
    title: 'Clean Removal',
    description: 'We’ll move or haul away your old appliance and the packaging'
  },
  {
    icon: <Returns size="large" />,
    title: 'Easy Returns',
    description: '48-hour return window for damages or defects'
  }
];

export const b2bProtectionPointsData = [
  {
    description: 'Aim to resolve all repairs in a single visit'
  },
  {
    description: 'Service visits not always required to solve issues'
  },
  {
    description: 'Fast 2-3 Day Service Guarantee based on location'
  },
  {
    description: 'No surprise deductibles or hidden fees'
  },
  {
    description: 'Unused services may be eligible for 30% reimbursement'
  }
];